import { useCallback } from 'react'
import { Textarea } from '../ui/Textarea'
import { ImproveTextButton } from '../ai/ImproveTextButton'
import { CVLabelInput } from './CVLabelInput'
import { useTranslation } from '../../contexts/LanguageContext'

interface SummaryFormProps {
  data: string | undefined
  onChange: (summary: string) => void
  customLabel?: string
  onCustomLabelChange: (value: string) => void
}

export function SummaryForm({ data, onChange, customLabel, onCustomLabelChange }: SummaryFormProps) {
  const { t } = useTranslation()

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      onChange(e.target.value)
    },
    [onChange]
  )

  const handleAiImprove = useCallback(
    (improvedText: string) => {
      onChange(improvedText)
    },
    [onChange]
  )

  return (
    <div>
      <CVLabelInput value={customLabel} placeholder="Summary" onChange={onCustomLabelChange} />
      <div className="flex items-center justify-between mb-1">
        <label className="block text-sm font-medium text-gray-700">
          {t.summaryForm.label}
        </label>
        <ImproveTextButton
          text={data || ''}
          context="summary"
          onAccept={handleAiImprove}
          disabled={!data?.trim()}
        />
      </div>
      <Textarea
        placeholder={t.summaryForm.placeholder}
        value={data || ''}
        onChange={handleChange}
        rows={4}
        hint={t.summaryForm.hint}
      />
    </div>
  )
}
